module.exports = __webpack_public_path__ + "static/media/pesa.3a729224.svg";